import { render, staticRenderFns } from "./commbookPreview.vue?vue&type=template&id=aab14b5c&scoped=true"
import script from "./commbookPreview.vue?vue&type=script&lang=js"
export * from "./commbookPreview.vue?vue&type=script&lang=js"
import style0 from "./commbookPreview.vue?vue&type=style&index=0&id=aab14b5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab14b5c",
  null
  
)

export default component.exports